import { Station } from '@mi-front/core';
import { useStationCtx } from '../../containers/StationCtx';

export function useActiveStation({ throwIfMissing }: { throwIfMissing?: boolean } = {}): Station {
  return useStationCtx({ innerThrowIfMissingProvider: throwIfMissing });
}
